import { BoardPositionEnum } from '@commenda/types';
import { fetcher } from '@commenda/utils';

type RelationshipFilePayload = {
  fileName: string;
  fileUrl: string;
  documentType: string;
};

export type TAddKeyPersonRelationshipParams = {
  isDirector?: boolean;
  roles?: BoardPositionEnum[];
  jobTitle?: string[];
  isAuthorizedSignatory?: boolean;
  isResponsibleParty?: boolean;
  filesToAdd?: RelationshipFilePayload[];
  isResidentDirector?: boolean;
};

export const addKeyPersonRelationship = async (
  businessEntityId: number,
  personId: number,
  body: TAddKeyPersonRelationshipParams
) => {
  const res = await fetcher(
    `business-entities/${businessEntityId}/persons/${personId}`,
    { method: 'POST', body }
  );

  return res;
};
